var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCurrentMagentoClient } from "@jti/magento";
import { getUser } from "@jti/rest-api";
import { clearFreeTrialRedirect, deleteAnonymousCart, getAnonymousCartId, setAnonymousCartId, } from "../../../../utils/cartHelpers";
import { fetchLoyaltyStatus, loyalty } from "../../../loyalty";
import { addFreeTrialProductToCart } from "../addProductToCart";
import { fetchCartItems, fetchTrialCartItems } from "../fetchCartItems";
const getAnonymousCart = (useAnonymous, isFreeTrial, storeName) => __awaiter(void 0, void 0, void 0, function* () {
    if (!isFreeTrial) {
        const magentoClient = getCurrentMagentoClient(isFreeTrial);
        const anonymousCartId = getAnonymousCartId(storeName, isFreeTrial);
        if (useAnonymous && anonymousCartId && !(yield magentoClient.checkCartAvailability(anonymousCartId))) {
            deleteAnonymousCart(storeName, isFreeTrial);
            return null;
        }
        return anonymousCartId;
    }
    return null;
});
const getFreeTrialCart = (freeTrialProduct, isCustomerCartExists, id) => __awaiter(void 0, void 0, void 0, function* () {
    const magentoClient = getCurrentMagentoClient(true);
    if (freeTrialProduct) {
        if (isCustomerCartExists) {
            const { items } = yield magentoClient.getCartItems(id);
            if (items) {
                yield magentoClient.removeItemsFromCart(id, items.map((item) => item.id));
            }
        }
        return addFreeTrialProductToCart(Object.assign(Object.assign({}, freeTrialProduct), { cartId: id }));
    }
    clearFreeTrialRedirect();
    return fetchTrialCartItems(id);
});
const fetchCartDeclaration = (isFreeTrial) => createAsyncThunk(isFreeTrial ? "freeTrialCart/fetchCart" : "cart/fetchCart", ({ useAnonymous, freeTrialProduct }, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const storeName = isFreeTrial ? "" : getState().cart.storeConfig.store_group_code;
    const user = getUser();
    const magentoClient = getCurrentMagentoClient(isFreeTrial);
    const anonymousCartId = yield getAnonymousCart(!!useAnonymous, isFreeTrial, storeName);
    const isUserFlow = !!user.magento_token;
    const isEmptyCartFlow = useAnonymous && !anonymousCartId;
    let isCustomerCartExists = false;
    let loyaltyStatus;
    let currentCart = {
        id: anonymousCartId,
        can_apply_coupons: true,
    };
    if (!getState().loyalty.isLoaded) {
        yield dispatch(fetchLoyaltyStatus());
        loyaltyStatus = getState().loyalty.status;
    }
    if (isUserFlow) {
        currentCart = yield magentoClient.getCustomerCart();
        isCustomerCartExists = true;
        if (loyaltyStatus && !isFreeTrial) {
            const loyaltyCampaignId = (_a = currentCart === null || currentCart === void 0 ? void 0 : currentCart.applied_campaign) === null || _a === void 0 ? void 0 : _a.loyalty_discount_uuid;
            if (loyaltyCampaignId) {
                dispatch(loyalty.actions.setLoyaltyCampaignId(loyaltyCampaignId));
            }
        }
    }
    else if (isEmptyCartFlow) {
        currentCart = yield magentoClient.createEmptyCart();
    }
    if (isUserFlow && anonymousCartId && useAnonymous && currentCart.id && !isFreeTrial) {
        yield magentoClient.mergeCarts(anonymousCartId, currentCart.id);
        dispatch(fetchCartItems(currentCart.id));
        deleteAnonymousCart(storeName, isFreeTrial);
    }
    else if (isEmptyCartFlow && !isFreeTrial) {
        setAnonymousCartId(currentCart.id, storeName, isFreeTrial);
    }
    if (isFreeTrial) {
        const action = yield getFreeTrialCart(freeTrialProduct, isCustomerCartExists, currentCart.id);
        dispatch(action);
    }
    return currentCart;
}));
export const fetchCart = fetchCartDeclaration(false);
export const fetchTrialCart = fetchCartDeclaration(true);
//# sourceMappingURL=fetchCart.js.map